import * as React from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Selector from "../../../components/Selector";
import SelectorChips from "../../../components/SelectorChips";
import { fetchSucursales, fetchUsuarios } from "../../../utils/generalsFetch";

/**
 * CreatePortfolioDialog
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - onSave: (payload) => void
 *  - branches?: string[]
 *  - officers?: string[]
 *  - productTypes?: string[]
 */
export default function CreatePortfolioDialog({
  open,
  onClose,
}) {
  const [officers, setOfficers] = React.useState([]);
  const [branches, setBranches] = React.useState([]);

  React.useEffect(() => {
    fetchUsuarios({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setOfficers(data);
    })
    fetchSucursales({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setBranches(data);
    })
  }, []);

  const [form, setForm] = React.useState({
    name: "",
    type: "By Loan Officer",
    description: "",
    officers: [],
    branch: "",
    sucursales: [],
    productTypes: [],
    active: false,
  });

  const [touched, setTouched] = React.useState({});

  const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));
  const markTouched = (key) => setTouched((t) => ({ ...t, [key]: true }));

  const nameError = touched.name && !form.name.trim();

  const handleSave = () => {
    // simple validation
    if (!form.name.trim()) {
      setTouched((t) => ({ ...t, name: true }));
      return;
    }
   
    const payload = {
      nombre: form.name.trim(),
      descripcion: form.description.trim(),
      "X-company-ID": localStorage.getItem('idcompany'),
      "X-Usuario-ID": localStorage.getItem('id'),
      officers: form.officers.map(officer => officer.value),
      sucursal: [form.branch],
      idcompany: localStorage.getItem('idcompany'),
      created_by: localStorage.getItem('id'),
      active: form.active,
    };



    fetch(`${process.env.REACT_APP_SERVER_URL}/api/portafolios`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Usuario-ID": localStorage.getItem('id'),
          "X-company-ID": localStorage.getItem('idcompany'),
        },
        body: JSON.stringify(payload),
      })
        .then(async (res) => {
          if (!res.ok) {
            const error = await res.json();
            throw new Error(error.error || "Error al crear portafolio");
          }
          return res.json();
        })
        .then((data) => {
          // Portafolio creado exitosamente
          handleClose();
        })
        .catch((err) => {
          alert(err.message || "Error al crear portafolio");
        });
  

  };

  const reset = () => {
    setForm({
      name: "",
      type: "By Loan Officer",
      description: "",
      officers: [],
      branch: "",
      sucursales: [],
      active: false,
    });
    setTouched({});
  };

  const handleClose = () => {
    reset();
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Crear Portafolio</DialogTitle>
      <DialogContent dividers>
        <Box >
          <Grid container columnSpacing={3}>
            <Grid item size={12}>
              <Typography variant="body2" color="text.secondary" fontWeight={600}>Nombre del Portafolio</Typography>
              <TextField
                placeholder="Portfolio Name"
                value={form.name}
                onChange={(e) => setField("name", e.target.value)}
                onBlur={() => markTouched("name")}
                required
                fullWidth
                error={Boolean(nameError)}
                helperText={nameError ? "Portfolio name is required" : " "}
              />
            </Grid>

         
            <Grid item size={12}>
              <Typography variant="body2" color="text.secondary" fontWeight={600}>Descripción (Opcional)</Typography>
              <TextField
                placeholder="Description (Optional)"
                value={form.description}
                onChange={(e) => setField("description", e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item size={6} mt={3}>
              <Typography variant="body2" color="text.secondary" fontWeight={600}>Asignar Gestor(es)</Typography>
              <Autocomplete
                multiple
                options={officers}
                value={form.officers}
                onChange={(_, v) => setField("officers", v)}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" label={option.label} {...getTagProps({ index })} key={option.value} />
                  ))
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                      {option.label+ " " + option.description}
                    </Typography>
                  </Box>
                )}
                renderInput={(params) => <TextField {...params}placeholder="Search..." />}
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1,display: "block" }}>
                Buscar y seleccionar uno o más gestores.
              </Typography>
            </Grid>

            <Grid item size={6} mt={3}>
              <Typography variant="body2" color="text.secondary" fontWeight={600}>Asignar Sucursal (Opcional)</Typography>
              <FormControl fullWidth>
                <Selector
                  sx={{backgroundColor: 'white'}}
                  placeholder="Asignar Sucursal (Optional)"
                  value={form.branch}
                  onChange={(e) => setField("branch", e.target.value)}
                  options={branches}
                />
              </FormControl>
            </Grid>

{/*            <Grid item size={12}>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Box>
                  <Typography variant="subtitle1">Asignación Automática de Reglas</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Habilitar para asignar prestamos automáticamente basado en reglas.
                  </Typography>
                </Box>
                <FormControlLabel
                  control={<Switch checked={form.autoAssign} onChange={(e) => setField("autoAssign", e.target.checked)} />}
                  label={form.autoAssign ? "Enabled" : "Disabled"}
                />
              </Stack>
            </Grid>
*/}

            <Grid item size={12}>
              <Divider sx={{ mt: 5 }} />
              <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
                <Typography variant="subtitle1">Estado del Portafolio</Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography variant="body2" color="text.secondary">
                    {form.active ? "Active" : "Inactive"}
                  </Typography>
                  <Switch checked={form.active} onChange={(e) => setField("active", e.target.checked)} />
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave} color="primarybutton" sx={{fontWeight:"bold"}}>Guardar Portafolio</Button>
      </DialogActions>
    </Dialog>
  );
}

